<script setup lang="ts">
import { ref } from "vue";
import { RouterLink } from "vue-router";
import BrandMark from "./BrandMark.vue";

const menuOpen = ref(false);
const links = [{ to: "/services", label: "Services" }, { to: "/process", label: "Process" }, { to: "/contact", label: "Contact" }];
</script>

<template>
  <header class="site-header" data-site-header><div class="shell site-header__bar">
    <RouterLink class="brand" to="/" aria-label="North Plan Digital - home"><BrandMark /><span class="brand__word">North Plan Digital</span></RouterLink>
    <button class="nav-toggle" type="button" :aria-expanded="menuOpen" aria-controls="primary-nav" data-nav-toggle @click="menuOpen = !menuOpen"><span class="sr-only">Menu</span><span class="nav-toggle__bars" aria-hidden="true" /></button>
    <nav id="primary-nav" class="site-nav" aria-label="Primary" data-nav-panel :data-open="menuOpen"><ul><li v-for="link in links" :key="link.to"><RouterLink :to="link.to" @click="menuOpen = false">{{ link.label }}</RouterLink></li></ul></nav>
  </div></header>
</template>
